import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment, faTimes } from '@fortawesome/free-solid-svg-icons'

const ChatToggleButton = ({ isOpen, unreadCount, onClick }) => (
    <div className="chat-toggle" onClick={onClick}>
        <FontAwesomeIcon
            icon={isOpen ? faTimes : faComment}
            size="lg"
            className="icon"
        />
        {!isOpen && unreadCount > 0 && (
            <span className="chat-badge">
                {unreadCount > 99 ? '99+' : unreadCount}
            </span>
        )}
    </div>
)

export default ChatToggleButton
